import Typography from "@mui/material/Typography";
import { FC } from "react";
import { COLOR_GREY_8 } from "shared/theme/colors";
import { UploadIcon } from "shared/theme/icons/UploadIcon";
import { fileExtensions } from "../../constants";
import { StyledUploadImageWrapper, StyledUploadInput } from "../../styled";

type BrowseFileProps = {
  onLogoUploaded: (e: { target: { files: FileList | null } | null }) => void;
  index?: number;
  disabled?: boolean;
};

const BrowseFile: FC<BrowseFileProps> = ({
  onLogoUploaded,
  index,
  disabled,
}) => {
  return (
    <StyledUploadImageWrapper>
      <StyledUploadInput flexGrow={1}>
        <UploadIcon />
        <input
          accept={fileExtensions}
          id="browse-file"
          type="file"
          multiple={false}
          onChange={onLogoUploaded}
          data-testid={`browse-file-${index}`}
          disabled={disabled}
        />
        <Typography variant="bodyMRegular" color={COLOR_GREY_8}>
          Browse to choose a file
        </Typography>
      </StyledUploadInput>
    </StyledUploadImageWrapper>
  );
};

export default BrowseFile;
